module.exports = __webpack_public_path__ + "img/open.bdd90a97.png";